export default {
  evaluation_list: {
    title: '評価依頼企業一覧',
    number_of_companies_answered: '回答数 {answered}社/{total}社',
    number_of_companies_displayed: '{total}件中{start}〜{end}件の表示',
    company_name: '会社名',
    status: 'ステータス',
    questionnaire: '調査票/サーベイ',
    plan: 'プラン',
    nothing: '該当する企業はありません。',
  },
  evidence_options: {
    all_plan: '全てのプラン',
    plans_with_vouchers: '証憑ありプラン',
    no_voucher_plan: '証憑なしプラン',
  },
  table_headers: {
    company_name: '会社名',
    status: 'ステータス',
    esg_rating: 'ESGレーティング',
    esg_score: 'ESGスコア',
    environment: '環境',
    social: '社会',
    governance: 'ガバナンス',
    plan: 'プラン',
    questionnaire: '調査票/サーベイ',
    answer_date: '回答日',
    answer_expires_date: '回答期限',
  },
  plan_list: {
    light: 'ライトプラン',
    starter: 'スタータープラン',
    basic: 'ベーシックプラン',
    standard: 'スタンダードプラン',
    enterprize: 'エンタープライズプラン',
  },
}
